import { useQuery } from "react-query";

import { getCitiesByProvince } from "api/getCitiesByProvince";

export const useGetCitiesByProvinceAndCountry = (province: string | null = "", country: string | null = "") => {
  const { data } = useQuery(
    `getCitiesByProvince-${province}${country ? `-${country}` : ""}`,
    () => getCitiesByProvince(province as string, country || ""),
    {
      enabled: !!province,
    }
  );

  return data || [];
};
